import React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import { theme } from './styles/theme';
import GlobalStyle from './styles/GlobalStyle';
import Homepage from './pages/Homepage';
import MainLayout from './components/MainLayout';
import Contact from './pages/Contact';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProjectPage from './pages/projectPage';
import NewsPage from './pages/NewsPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
      <ScrollToTop /> 
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Homepage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="apropos" element={<AboutPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="projets" element={<ProjectPage />} />
          <Route path="actualites" element={<NewsPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="privacy" element={<PrivacyPolicyPage />} />
        </Route>
      </Routes>

      </Router>
    </ThemeProvider>
  );
};

export default App;